<template>
  <div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label" for="note">
            {{computeCaption(fields_en['note'], $store.state.lang.value.toLowerCase())}}
          </label>
          <div class="custom-file">
            <el-input id="note" type="textarea" v-model="model.note"  onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Input} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'

export default {
  components: {
    [Input.name]: Input
  },
  mixins: [TranslationsUtils],
  data () {
    return {
      model: {note: ''},
      fields_en: {
        note: 'Note'
      }
    }
  },
  watch: {
    'model': {
      handler: function (value) {
        this.$emit('updateModel', this.model)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/Note.vue